<div class="kw-page" [nbSpinner]="this.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">{{"Inventory" | tenantWords}} On Hand</h2>
      <span class="page-subtitle">On-hand quantity by stock locator, grower, and lot</span>
    </div>
    <div class="header-actions">
      <button mat-stroked-button class="header-btn" (click)="exportExcel()" [disabled]="this.isLoading">
        <fa-icon [icon]="faFileExcel" class="me-2"></fa-icon>Export
      </button>
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="onSyncInventory()" [disabled]="this.isLoading">
        <fa-icon [icon]="faSync" class="me-2"></fa-icon>Sync {{"Inventory" | tenantWords}}
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <div class="search-box">
      <fa-icon [icon]="faSearch" class="search-icon"></fa-icon>
      <input type="text" placeholder="Search by locator, item, grower, lot, or pool..."
        [(ngModel)]="searchTerm" (ngModelChange)="applySearch()" class="search-input" aria-label="Search on-hand inventory">
    </div>
    <button mat-stroked-button type="button" class="clear-btn" (click)="clearFilters()"
      [disabled]="!this.filterCount && !this.searchTerm">
      <fa-icon [icon]="faBan" class="me-2"></fa-icon>Clear Filters
      <span class="count-pill" *ngIf="this.filterCount">{{this.filterCount}}</span>
    </button>
  </div>

  <div class="grid-card static">
    <ejs-grid #grid *ngIf="!this.isLoading" [dataSource]="this.rows" [columns]="this.columns"
      [allowPaging]="true" [pageSettings]="this.pageSettings" [allowSorting]="true"
      [allowFiltering]="true" [filterSettings]="this.filterSettings" [allowTextWrap]="true"
      [enableStickyHeader]="true" [enableHover]="true" [allowExcelExport]="true"
      [aggregates]="this.aggregates"
      (excelAggregateQueryCellInfo)="aggregateQueryCellInfo($event)"
      (actionComplete)="onActionComplete($event)" (dataBound)="onGridDataBound()">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card static" *ngFor="let row of this.rows | slice:0:mobileVisibleCount; trackBy: trackByRow">
      <div class="m-card-top">
        <span class="m-card-name">{{"Lot" | tenantWords}} {{row.LOT_NUMBER || '—'}}</span>
        <span class="type-pill">{{row.ONHAND_QUANTITY | number}} on hand</span>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="row.ITEM_DESCRIPTION">
          <fa-icon [icon]="faBox" class="m-meta-icon"></fa-icon>{{row.ITEM_DESCRIPTION}}
        </div>
        <div class="m-meta-line" *ngIf="row.GROWER">
          <fa-icon [icon]="faTractor" class="m-meta-icon"></fa-icon>{{row.GROWER}}
        </div>
        <div class="m-meta-line" *ngIf="row.STOCK_LOCATOR">
          <fa-icon [icon]="faWarehouse" class="m-meta-icon"></fa-icon>{{row.STOCK_LOCATOR}}<ng-container *ngIf="row.CERT_ROOM"> · {{row.CERT_ROOM}}</ng-container>
        </div>
        <div class="m-meta-line" *ngIf="row.dateReceived">
          <fa-icon [icon]="faCalendar" class="m-meta-icon"></fa-icon>Received {{row.dateReceived}}<ng-container *ngIf="row.bornOnDate"> · BOD {{row.bornOnDate}}</ng-container>
        </div>
      </div>

      <div class="m-card-foot" *ngIf="row.POOL_CODE || row.TREATMENT || row.LOT_QUALIFICATION">
        <span class="type-pill" *ngIf="row.POOL_CODE">Pool {{row.POOL_CODE}}</span>
        <span class="type-pill" *ngIf="row.TREATMENT">{{row.TREATMENT}}</span>
        <span class="type-pill" *ngIf="row.LOT_QUALIFICATION">{{row.LOT_QUALIFICATION}}</span>
      </div>
    </div>

    <div class="m-empty" *ngIf="!this.rows.length && !this.isLoading">
      <fa-icon [icon]="faBox" class="m-empty-icon"></fa-icon>
      <div>No {{"inventory" | tenantWords}} matches your search</div>
    </div>

    <button class="m-show-more" *ngIf="this.rows.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{this.rows.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>
